import styled, { css } from "styled-components";
import { FooterTipProps } from "./FooterTip";

interface TipTypeProp {
  tipType: FooterTipProps['tipType'];
}

const handleTipType = (tipType: FooterTipProps['tipType']) => {
  if (tipType === 'tip') {
    return css`
      background-color: #EFF2F7;
      color: #88979B;
    `;
  }
  else if (tipType === 'error') {
    return css`
      background-color: #D9534F;
      color: #FFFFFF;
    `;
  }
};

export const TipContainer = styled.div<TipTypeProp>`
  display: flex;
  align-items: center;
  border-radius: 60px;
  padding: 9px 15px;
  gap: 6px;

  ${({ tipType }) => handleTipType(tipType)};
`;

export const TipText = styled.div`
  font-size: 14px;
  line-height: 17px;
`;

export const TipIcon = styled.i`
  font-size: 17px;
  color: #88979B;
`;
